import { onClickSelectors } from '@src/scripts/lib/event';
import { trackGtmEvent } from '@src/scripts/lib/gtm';
import { getPageSection, isMehrErfahrenLink } from '@src/scripts/lib/dom';

onClickSelectors(
	'a[href$="/bewerbung/"].btn,a[href$="/application/"].btn,a[href="/bewerbung/"],a[href$="/application/"]',
	( { target } ) => {
		trackGtmEvent( 'ga_event', {
			category: 'click_button',
			event_action: 'bewerben',
			event_label: getPageSection( target as HTMLElement ),
			button_group: 'action',
		} );
	}
);

onClickSelectors(
	'a[href$="/infomaterial/"].btn,a[href$="/request-information/"].btn,a[href="/infomaterial/"],a[href="/request-information/"]',
	( { target } ) => {
		trackGtmEvent( 'ga_event', {
			category: 'click_button',
			event_action: 'infomaterial anfordern',
			event_label: getPageSection( target as HTMLElement ),
			button_group: 'action',
		} );
	}
);

onClickSelectors(
	'.dhsv_vc_termine_calendar a.anmelden,.dhsv_event_slider a[href*="?prefill="]',
	( { target } ) => {
		trackGtmEvent( 'ga_event', {
			category: 'click_button',
			event_action: 'anmelden',
			event_label: getPageSection( target as HTMLElement ),
			button_group: 'information',
		} );
	}
);

onClickSelectors( 'a', ( e, currentTarget ) => {
	if ( isMehrErfahrenLink( currentTarget as HTMLElement ) ) {
		trackGtmEvent( 'ga_event', {
			category: 'click_button',
			event_action: 'mehr info',
			event_label: getPageSection( currentTarget as HTMLElement ),
			button_group: 'information',
		} );
	}
} );

onClickSelectors( '.floating-menu div.innertoggle', ( e, currentTarget ) => {
	if ( ! currentTarget.matches( '.toggle.active div.innertoggle' ) ) {
		return;
	}
	trackGtmEvent( 'ga_event', {
		category: 'click_button',
		event_action: 'kontakt flyout',
		event_label: 'buttom',
	} );
} );
